import React from "react";
import PropTypes from "prop-types";
//import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
import { isEmpty, queryStringBuilder/*, convertDatestampToObject, getLocaleDateString*/ } from "../helpers";
//import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
//import { Button } from '@progress/kendo-react-buttons';
import "@progress/kendo-theme-material/dist/all.css";
import isPage from "../hoc/isPage";
//import { AppContext } from '../context/AppContext';
import FormSection from '../components/FormSection';
import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import {
    GridColumn as Column/*,
    GridToolbar,
    GridDetailRow,*/
} from "@progress/kendo-react-grid";
import { BlankCell } from "../components/utils/GridHelpers";
import GridContainer/*, { GridContainerToolbar, GridContainerToolbarOption }*/ from '../components/GridContainer';

class PartDemandPage extends React.Component {
    static propTypes = {
        orgID: PropTypes.number,
        orgVendorID: PropTypes.string,
        vendorID: PropTypes.number,
        partNumber: PropTypes.string
    }

    state = {
        details: null
    }

    componentDidMount() {

        let builder = new queryStringBuilder();
        if (this.props.orgID)
            builder.append("orgID", this.props.orgID);
        if (!isEmpty(this.props.orgVendorID))
            builder.append("orgVendorID", this.props.orgVendorID);
        if (this.props.vendorID)
            builder.append("vendorID", this.props.vendorID);
        builder.append("partNumber", this.props.partNumber);

        // filter the data
        this.props
            .getData(
                `/api/portal/part/GetPartDemandDetails${builder.queryString}`
            )
            .then(response => {
                const details = response.data;

                if (details) {
                    this.setState({
                        details: details
                    });
                }
            })
            .catch(error => {
                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0576", "", this.props.partNumber)
                );
            });
    }

    //<div className="k-window-title k-dialog-title exception-settings">Part Demand</div>
    render() {
        const details = this.state.details;

        let next30DayForecast;
        let icon;
        if (details) {
            if (details.next30DayForecast === null)
                next30DayForecast = this.props.returnLocalizedString("m0013");
            else if (details.next30DayForecast < 1)
                next30DayForecast = this.props.returnLocalizedString("m0577");
            else
                next30DayForecast = details.next30DayForecast.toFixed(2);

            switch (details.last30DaysVsNext30Days) {
                case 0:
                    icon = <span className="k-icon" />
                    break;
                case 1:
                    icon = <span className="k-icon k-i-sort-desc-sm" />;
                    break;
                case 2:
                    icon = <span className="k-icon k-i-sort-asc-sm" />;
                    break;
                default:
                    break;
            }
        }

        //!DBTRANS! @m0013@ N/A !DEVNOTE! Action status
        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0143@ Part Number:%space%  !DEVNOTE! Field label
        //!DBTRANS! @m0144@  Vendor:%space%  !DEVNOTE! Field label
        //!DBTRANS! @m0576@ Unable to retrieve part demand details of %var1%. Please try again. !DEVNOTE! Action status
        //!DBTRANS! @m0577@ <1 !DEVNOTE!
        //!DBTRANS! @m0578@ Qty on order !DEVNOTE!
        //!DBTRANS! @m0579@ Qty available !DEVNOTE!
        //!DBTRANS! @m0580@ 30 day demand forecast !DEVNOTE! Chart label
        //!DBTRANS! @m0581@ Jan !DEVNOTE! Month label
        //!DBTRANS! @m0582@ Feb !DEVNOTE! Month label
        //!DBTRANS! @m0583@ Mar !DEVNOTE! Month label
        //!DBTRANS! @m0584@ Apr !DEVNOTE! Month label
        //!DBTRANS! @m0585@ May !DEVNOTE! Month label
        //!DBTRANS! @m0586@ Jun !DEVNOTE! Month label
        //!DBTRANS! @m0587@ Jul !DEVNOTE! Month label
        //!DBTRANS! @m0588@ Aug !DEVNOTE! Month label
        //!DBTRANS! @m0589@ Sep !DEVNOTE! Month label
        //!DBTRANS! @m0590@ Oct !DEVNOTE! Month label
        //!DBTRANS! @m0591@ Nov !DEVNOTE! Month label
        //!DBTRANS! @m0592@ Dec !DEVNOTE! Month label
        //!DBTRANS! @m0593@ Total !DEVNOTE! Time label
        //!DBTRANS! @m0510@ Year !DEVNOTE! 

        return (
            <div className="position-relative">
                <div className="grid">
                    <div className="grid-row">
                        <div className="grid-col m-col-12 d-col-12">
                            <div className="k-dialog-title2">{this.props.returnLocalizedString("m0143")}<span>{this.props.partNumber}</span> {this.props.returnLocalizedString("m0144")} <span>{details ? details.vendorCode : ""}</span></div>
                            <div className="k-dialog-warning">
                                {details ? details.description : ""}
                            </div>
                            <FormSection>
                                <div>
                                    <span className="k-form-field right-margin-20">
                                        <label htmlFor="qtyOnOrder">{this.props.returnLocalizedString("m0578")}</label>
                                    </span>
                                    <span className="k-form-field">
                                        <label className="value-label" id="qtyOnOrder" name="qtyOnOrder" >{details ? details.qtyOnOrder : undefined}</label>
                                    </span>
                                </div>
                                <div>
                                    <span className="k-form-field right-margin-20">
                                        <label htmlFor="quantityAvailable">{this.props.returnLocalizedString("m0579")}</label>
                                    </span>
                                    <span className="k-form-field">
                                        <label className="value-label" id="quantityAvailable" name="quantityAvailable" >{details ? details.quantityAvailable : undefined}</label>
                                    </span>
                                </div>
                                <div>
                                    <span className="k-form-field right-margin-20">
                                        <label style={{ marginBottom: '30px' }} htmlFor="next30DayForecast">{this.props.returnLocalizedString("m0580")}</label>
                                    </span>
                                    <span className="k-form-field">
                                        <label className="value-label" id="next30DayForecast" name="next30DayForecast" >{details ? next30DayForecast : undefined}</label>
                                        {icon}
                                    </span>
                                </div>
                                <div className="dropdown" >
                                    <GridContainer
                                        data={details ? details.salesHistory : undefined}
                                        sortColumn=""
                                    >
                                        <Column
                                            field="year"
                                            title={this.props.returnLocalizedString("m0510")}
                                            width="50"
                                        />
                                        <Column
                                            field="jan"
                                            title={this.props.returnLocalizedString("m0581")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="feb"
                                            title={this.props.returnLocalizedString("m0582")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="mar"
                                            title={this.props.returnLocalizedString("m0583")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="apr"
                                            title={this.props.returnLocalizedString("m0584")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="may"
                                            title={this.props.returnLocalizedString("m0585")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="jun"
                                            title={this.props.returnLocalizedString("m0586")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="jul"
                                            title={this.props.returnLocalizedString("m0587")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="aug"
                                            title={this.props.returnLocalizedString("m0588")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="sep"
                                            title={this.props.returnLocalizedString("m0589")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="oct"
                                            title={this.props.returnLocalizedString("m0590")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="nov"
                                            title={this.props.returnLocalizedString("m0591")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="dec"
                                            title={this.props.returnLocalizedString("m0592")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="40"
                                        />
                                        <Column
                                            field="total"
                                            title={this.props.returnLocalizedString("m0593")}
                                            className='numeric'
                                            headerClassName='numeric'
                                            width="50"
                                        />
                                        <Column
                                            excludeFromExport
                                            filterable={false}
                                            resizable={false}
                                            sortable={false}
                                            reorderable={false}
                                            editable={false}
                                            cell={(props) => (
                                                <BlankCell {...props} />
                                            )}
                                        />
                                    </GridContainer>
                                </div>
                            </FormSection>
                            <Toolbar onEditScrtooltip={false} atBottom={true} >
                                <ToolbarOption onEditScrtooltip={false} type="close2" primary={true} handleClick={this.props.handleCloseModal} />
                            </Toolbar>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default isPage(PartDemandPage);



// WEBPACK FOOTER //
// ./src/containers/PartDemandPage.js